import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-email-pf',
  templateUrl: './email-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./email-pf.component.css']
})
export class EmailPfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.email===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.email===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
